module.exports = __webpack_public_path__ + "img/white.8422d06.svg";